export enum ApiType {
  merchantSearch = "merchant/search{}",
  getMerchantById = "merchant/{}",
  getMerchants = "merchant",
  getProductsByMerchantId = "merchant/{}/product",
  registerMerchant = "merchant/register",
  merchantLogin = "merchant/login",
  merchantForgetPassword = "user/forgot-password",
  merchantChangePassword = "account/password",
  merchantVerifyForgetPassword = "account/forgot-password/verify/{}",
  merchantUpdateAccount = "merchant/{}",
  claimMerchant = "merchant/{}/claim",
  subscribeCustomerEmail = "customer/email/subscribe",
  confirmEmailSubscription = "customer/email/subscribe/confirm/{}",
  customerLogin = "customer/login",
  customerRegister = "customer/register",
  customerForgetPassword = "customer/forgot-password",
  customerUpdateInfo = "account",
  customerChangePassword = "account/password",
  resendCustomerVerificationEmail = "customer/email/verify/resend",
  customerEmailVerification = "customer/email/verify/{}",
  resendEmailVerification = "user/email/verify/resend",
  verifyEmail = "user/email/verify/{}",
  addMerchantPhone = "merchant/{}/phone",
  resendMerchantVerificationSMSCode = "merchant/{}/phone/resendCode",
  verifyMerchantCode = "merchant/{}/phone/verify/{}",
  getMerchantFilters = "merchant/filters",
  getProductById = "product/{}",
  getAllProducts = "product",
  getCategoryById = "category/{}",
  getAllCategories = "category",
  getFirebaseToken = "account/firebaseToken",
  addMerchantRating = "merchant/{}/rating",
  getAllMerchantRatings = "merchant/rating",
  getMerchantRatingById = "merchant/{}/rating",
  addProductRating = "product/{}/rating",
  getProductRating = "product/{}/rating",
  logout = "account/logout",
  DELETE_RATE = "rating/{}"
}
